import http from '../plugins/axios'

export const getAllPlatformList = async () => {
  try {
    const response = await http.get(`/api/v2/platform-lists`)
    return response.data
  } catch(error) {
    throw error
  }
}